<template>
  <a-select v-model:value="current" @search="filterNameInitial" :filterOption="filter" showSearch style="width: 201px;margin-right:10px">
    <a-select-option v-for="item in list" :value="item.name" :key="item.id || item.name">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  data() {
    return {
      myFilter: "",
    };
  },
  created() {},
  mounted() {},
  activated() {},
  emits: ['update:modelValue'],
  //获取父元素传值
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  computed: {
    list() {
      // 修复：增加防御性判断。如果 store 里的数据还未加载或是非数组，默认返回空数组
      let list = this.$store.state.syndromeList;
      if (!list || !Array.isArray(list)) {
        return [];
      }

      if (!this.myFilter) {
        return list.slice(0, 200);
      }
      
      return list.filter(item => 
        item.name?.toLowerCase().includes(this.myFilter) || 
        item.nameInitial?.toLowerCase().includes(this.myFilter)
      ).slice(0, 200);
    },
    current: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
  methods: {
    filterNameInitial(input) {
      this.myFilter = input?.toLowerCase();
    },
    filter() {
      // a-select 开启了 showSearch 但我们自己接管了过滤逻辑，这里固定 return true 即可
      return true;
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  align-items: center;
}

.head span {
  font-weight: bold;
  margin-right: 10px;
}
</style>